import {
    EVENT_CINEMAS,
    HOYTS_CINEMAS,
    LUNA_CINEMAS,
    MOVING_STORY,
    ORANA_CINEMAS,
    PALACE_CINEMAS,
    READING_CINEMAS,
    UNITED_CINEMAS,
    VILLAGE_CINEMAS
} from "@config/config";

export default function getCinemaGroupName(id) {
    switch (id) {
        case HOYTS_CINEMAS: return { name: "HOYTS", article: "a" };
        case VILLAGE_CINEMAS: return { name: "Village", article: "a" };
        case EVENT_CINEMAS: return { name: "Event", article: "an" };
        case LUNA_CINEMAS: return { name: "Luna", article: "a" };
        case PALACE_CINEMAS: return { name: "Palace", article: "a" };
        case READING_CINEMAS: return { name: "Reading", article: "a" };
        case ORANA_CINEMAS: return { name: "Orana", article: "an" };
        case MOVING_STORY: return { name: "Moving Story", article: "a" };
        case UNITED_CINEMAS: return { name: "United Cinemas", article: "a" };
        default: return null;
    }
}
